export function newPasswordError (value) {
  if (typeof value !== 'string') return 'รหัสผ่านต้องยาว 6–128 ตัวอักษร'
  const characters = Array.from(value)
  if (characters.length < 6 || characters.length > 128) return 'รหัสผ่านต้องยาว 6–128 ตัวอักษร'
  const lower = value.toLowerCase()
  const common = ['passwordpassword', 'password123456789', 'letmeinletmein123', 'iloveyouiloveyou']
  const sequences = ['012345678901234567890123456789', 'abcdefghijklmnopqrstuvwxyz', 'qwertyuiopasdfghjklzxcvbnm']
  if (common.includes(lower) || sequences.some(sequence => sequence.includes(lower))) return 'กรุณาใช้รหัสผ่านที่คาดเดายากและไม่ใช่อักษรหรือตัวเลขซ้ำ'
  for (let period = 1; period <= 4; period++) {
    if (characters.every((character, index) => character === characters[index % period])) return 'กรุณาใช้รหัสผ่านที่คาดเดายากและไม่ใช่อักษรหรือตัวเลขซ้ำ'
  }
  return ''
}
